//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    template: {
      type: Object,
      required: true
    }
  },
  computed: {
    types () {
      return this.template.clientTypes
    },
    campaignRef () {
      return `${this.template.id}|${this.template.slug}`
    }
  },
  mounted () {
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) {
        // Hide modal if user comes back to the page with backwards navigation to prevent showing invalid state
        this.$emit('input', false)
      }
    })
  },
  methods: {
    hide () {
      this.$ph.capture('create_contract_modal_closed')
      this.$emit('input', false)
    },
  }
}
